import React,{ useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import ConfirmationDialogRaw from '../components/ConfirmationDialogRaw';
import { 
  features,
  dateStyle,
  language
} from 'config';
import { FirebaseContext } from 'common';

const DeliveryHistory = () => {
  const { api } = useContext(FirebaseContext);
  const {
    cancelBooking
  } = api;
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const [role, setRole] = useState(null);

  const columns =  [
      {title: language.booking_date, field: 'tripdate', render: rowData => rowData.tripdate?new Date(rowData.tripdate).toLocaleString(dateStyle):null},
      { title: language.booking_status, field: 'status', render: rowData => <span>{language[rowData.status]}</span> },
      { title: language.trip_cost, field: 'trip_cost' },
      { title: language.drop_address, field: 'dropAddress' },
      { title: language.deliveryPerson, field: 'deliveryPerson' },
      { title: language.deliveryPersonPhone, field: 'deliveryPersonPhone' },
      { title: language.pickUpInstructions, field: 'pickUpInstructions' },
      { title: language.parcel_type, render: rowData => <span>{rowData.parcelTypeSelected?rowData.parcelTypeSelected.description + " (" + rowData.parcelTypeSelected.amount + ")":""}</span> },
      { title: language.parcel_option, render: rowData => <span>{rowData.optionSelected?rowData.optionSelected.description + " (" + rowData.optionSelected.amount + ")":""}</span> },
      { title: language.assign_driver, field: 'driver_name' },
      { title: language.trip_start_time, field: 'trip_start_time' },
      { title: language.trip_end_time, field: 'trip_end_time' },
      { title: language.discount_ammount, field: 'discount'},
      { title: language.booking_id, field: 'id' }
  ];
  const [data, setData] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState('');
  const bookinglistdata = useSelector(state => state.bookinglistdata);

  useEffect(()=>{
        if(bookinglistdata.bookings){
            setData(bookinglistdata.bookings);
        }else{
          setData([]);
        }
  },[bookinglistdata.bookings]);

  useEffect(() => {
    if(auth.info && auth.info.profile){
      setRole(auth.info.profile.usertype);
    }
  }, [auth.info]);

  const onConfirmClose=(value)=>{
    if(value){
      dispatch(cancelBooking({
        reason:value,
        booking:selectedBooking
      }));
    }
    setOpenConfirm(false);
  }
  
  return (
    bookinglistdata.loading? <CircularLoading/>:
    <div>
    <MaterialTable
      title={language.booking_title}
      columns={columns}
      data={data}
      options={{
        pageSize:50,       // make initial page size
        emptyRowsWhenPaging: false,   // To avoid of having empty rows
        pageSizeOptions:[50,100,150],    // rows selection options
        actionsColumnIndex: -1,
        exportButton: features.AllowCriticalEditsAdmin,
        sorting: true,
        searchFieldAlignment:'left',
        headerStyle: {
          backgroundColor: '#81b541',
          color: '#fff',
          fontWeight:"bold"
        },
      }}
      // actions={[
      //   rowData => ({
      //     icon: 'cancel',
      //     tooltip: language.cancel_booking,
      //     disabled: rowData.status==='NEW' || rowData.status==='ACCEPTED' || rowData.status==='PAYMENT_PENDING'? false:true,
      //     onClick: (event, rowData) => {
      //       if(features.AllowCriticalEditsAdmin && (role==='dispatcher' || role==='professional' || role ==='admin')){
      //         if(rowData.status==='NEW' || rowData.status==='ACCEPTED'){
      //           setSelectedBooking(rowData);
      //           setOpenConfirm(true);
      //         }else{
      //           setTimeout(()=>{
      //             dispatch(cancelBooking({
      //               reason: language.cancelled_incomplete_booking,
      //               booking:rowData
      //             }));
      //           },1500);
      //         }
      //       }else{
      //         alert(language.demo_mode);
      //       }
      //     }         
      //   }),
      // ]}
    />
    <ConfirmationDialogRaw
      open={openConfirm}
      onClose={onConfirmClose}
      value={''}
    />
    </div>

  );
}

export default DeliveryHistory;
